import { Navigate, useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { categoryMeta, getWorksByType, type MediaType } from '@/mocks/catalog';
import CatalogBrowser from '@/pages/category/components/CatalogBrowser';

const validTypes: MediaType[] = ['movie', 'tv', 'show'];

export default function CategoryPage() {
  const { type } = useParams<{ type: string }>();
  const isValid = type && validTypes.includes(type as MediaType);
  const mediaType = (isValid ? type : 'movie') as MediaType;
  const meta = categoryMeta[mediaType];
  const list = getWorksByType(mediaType);

  useSeo({
    title: `${meta.en} - 91大神影视平台`,
    description: `${meta.desc}。91大神${meta.name}提供丰富的影视资源信息与便捷的多维筛选，帮助你快速找到想看的作品。`,
    keywords: `91大神, ${meta.en}, ${mediaType === 'movie' ? '电影资源, 高清电影' : mediaType === 'tv' ? '剧集推荐, 追剧' : '综艺节目, 真人秀'}, 影视筛选`,
    canonicalPath: `/category/${mediaType}`,
  });

  if (!isValid) {
    return <Navigate to="/category/movie" replace />;
  }

  return (
    <SiteLayout>
      <div className="w-full px-4 py-6 md:px-8 md:py-8">
        <div className="mx-auto w-full max-w-[1400px]">
          <CatalogBrowser type={mediaType} list={list} />
        </div>
      </div>
    </SiteLayout>
  );
}